export default {
  BEFORE_FETCH: null,
  RECEIVE_DATA: 'RECEIVE_DATA',
  CHANGE_PRODUCT_LIST_VIEW: null,
  INIT_I18N: null,
  CHANGE_REVIEW_STAR_RATING: null,
  CLOSE_SEARCH_POPUP: null,
  CHANGE_SEARCH_BAR_VIEW: null,
  CHANGE_SEARCH_TEXT: null,
  CHANGE_PRODUCT_QUANTITY: null,
  CHANGE_PASSWORD_VIEW: null,
  CHANGE_Tick_VIEW: null,
  CLOSE_VERIFYPARTNER_MODAL: null,
};
